import React from 'react'
import { WorkflowDetails } from '../../../components/CustomWorkflows/WorkflowDetails'
import { Modal } from '../../../components/Modal/Modal'
import { type CustomWorkflowSummary } from '../../../store/customWorkflow/customWorkflows'
import { ENTITY_TAGS, entityTagsOf } from '../../../components/CustomWorkflows/entityTags'
import { WorkflowParametersSection } from '../../../components/CustomWorkflows/parameters/WorkflowParametersSection'
import { useWorkflowParametersModal } from './useWorkflowParametersModal'

interface ConfigureWorkflowModalProps {
  accountId: string
  workflow: CustomWorkflowSummary
  show: boolean
  onHide: () => void
}

export const ConfigureWorkflowModal: React.FC<ConfigureWorkflowModalProps> = ({ accountId, workflow, show, onHide }) => {
  const { hasParameters, modalProps, sectionProps } = useWorkflowParametersModal(workflow.id, onHide)
  const runHints = entityTagsOf(workflow).map((value) => `Run from ${ENTITY_TAGS[value].runFrom}`)

  return (
    <Modal
      show={show}
      {...modalProps}
      bodyClassName='pb-4'
      header={<h5 className='mb-0'>{workflow.name || workflow.id}</h5>}
      body={
        <div className='d-flex flex-column zocks-gap-2'>
          <WorkflowDetails workflow={workflow} className='paragraph-medium zocks-text-gray-700' />
          {runHints.length ? (
            <div className='d-flex flex-column'>
              {runHints.map((hint) => (
                <div key={hint} className='paragraph-small zocks-text-gray-600'>
                  {hint}
                </div>
              ))}
            </div>
          ) : null}
          <WorkflowParametersSection accountId={accountId} workflowId={workflow.id} {...sectionProps} />
          {hasParameters === false ? <div className='border-top pt-3 paragraph-small zocks-text-gray-600'>This workflow has no settings.</div> : null}
        </div>
      }
    />
  )
}
